import { Link } from 'react-router';
import { BRAND } from '@br/protocol';
import { usePageTitle } from '../lib/title';

export function NotFoundPage() {
  usePageTitle('페이지를 찾을 수 없음');
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-3 px-4 py-24 text-center">
      <p className="text-sm font-medium text-ink-muted">{BRAND.name}</p>
      <h1 className="text-2xl font-bold text-ink">페이지를 찾을 수 없습니다</h1>
      <p className="text-sm text-ink-muted">
        주소가 잘못되었거나 더 이상 존재하지 않는 페이지입니다.
      </p>
      <div className="mt-2 flex gap-3 text-sm">
        <Link to="/profiles" className="text-primary hover:underline">
          운영자 화면으로
        </Link>
        <Link to="/join" className="text-primary hover:underline">
          고객 접속 코드 입력
        </Link>
      </div>
    </div>
  );
}
